export default __webpack_public_path__ + "static/Vumography-BG5-563c1bd0c1006928e7ccb671db585156.webp";